import { render, staticRenderFns } from "./Recipt.vue?vue&type=template&id=4a037e6f&scoped=true"
import script from "./Recipt.vue?vue&type=script&lang=js"
export * from "./Recipt.vue?vue&type=script&lang=js"
import style0 from "./Recipt.vue?vue&type=style&index=0&id=4a037e6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a037e6f",
  null
  
)

export default component.exports